export default {
  errors: {
    emailAlreadyRegistered:
      'E-Mail bereits registriert, bitte versuche dich einzuloggen.',
    invalidEmail: 'Ungültige E-Mail, bitte versuche es erneut.'
  },
  title: 'Registrieren',
  subtitle: 'Erstelle ein neues Vamoz-Konto',
  success: {
    title: 'Überprüfe dein E-Mail-Postfach ✉️',
    message:
      'Wir haben dir eine E-Mail mit einem Link zur Verifizierung deines Kontos gesendet. Es kann ein paar Minuten dauern bis diese ankommt. Bitte überprüfe auch deinen Spam-Ordner.'
  },
  confirmation: {
    confirmed: {
      title: 'E-Mail bestätigt!',
      message:
        'Deine E-Mail-Adresse wurde bestätigt. Du kannst dich jetzt bei Vamoz anmelden.'
    },
    alreadyConfirmed: {
      title: 'Link bereits verwendet',
      message:
        'Dieser Bestätigungslink wurde bereits verwendet oder wird gerade verarbeitet. Wenn dein Konto bereit ist, kannst du dich unten anmelden.'
    },
    expired: {
      title: 'Bestätigungslink abgelaufen',
      message:
        'Kehre zum Registrierungslink deines Unternehmens zurück und gib deine E-Mail-Adresse erneut ein. Kontaktiere deine Unternehmensadministration, falls du den Link nicht mehr hast.'
    },
    invalid: {
      title: 'Ungültiger Bestätigungslink',
      message:
        'Öffne die neueste Bestätigungs-E-Mail oder fordere über den Registrierungslink deines Unternehmens eine neue E-Mail an.'
    },
    unavailable: {
      title: 'Bestätigung vorübergehend nicht verfügbar',
      message:
        'Versuche den Link in einigen Minuten erneut. Kontaktiere den Support, falls das Problem weiterhin besteht.'
    }
  },
  goToLogin: 'Zum Login',
  button: 'Registrieren',
  allowedDomains: 'Erlaubte Domains: {domains}',
  help: 'Hilfe',
  instructions: {
    title: 'Anleitung zur Registrierung',
    subtitle:
      'Bitte folge diesen drei Schritten, um dich bei Vamoz zu registrieren.',
    step1: 'Gib deine E-Mail-Adresse ein (von einer erlaubten Domain)',
    step2: 'Überprüfe dein E-Mail-Postfach (kann ein paar Minuten dauern)',
    step3:
      'Klicke auf den Link in der E-Mail, um deine E-Mail-Adresse zu bestätigen',
    spamFolder:
      'Wenn du die E-Mail nicht in deinem Posteingang siehst, überprüfe bitte deinen Spam-Ordner.'
  }
};
